import React from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import { Label, Block } from '../..';
import constants from '../../../../core/constants';

const getJustify = (f: any, l: any) => {
  let j = 'center';
  if (f) {
    j = 'flex-end';
  }
  if (l) {
    j = 'flex-start';
  }

  return j;
};

const SingleDayMonthWrap = styled.div.attrs((pr: any) => ({
  isFirstDayWeek: pr.isFirstDayWeek,
  isLastDayWeek: pr.isLastDayWeek
}))`
  display: inline-flex;
  width: 100%;
  width: 40px;
  text-align: center;
  align-items: center;
  // justify-content: ${(p) => getJustify(p.isFirstDayWeek, p.isLastDayWeek)};
  justify-items: center;
  height: 40px;
  @media (max-width: 768px) {
    width: 14.285714%;
  }
`;
// const WeekDay = styled.div.attrs((pr: any) => ({
//   isFirstDayWeek: pr.isFirstDayWeek,
//   isLastDayWeek: pr.isLastDayWeek,
//   isInsideWeek: pr.isInsideWeek,
//   isSelectedDay: pr.isSelectedDay
// }))`
//   background: #efeffe;
//   width: ${(p) => (p.isFirstDayWeek || p.isLastDayWeek ? '25px' : '40px')};
//   height: 26px;
//   align-content: ${(p) => (p.isLastDayWeek ? 'flex-start' : 'inherit')};
//   align-content: ${(p) => (p.isFirstDayWeek ? 'flex-end' : 'inherit')};
//   justify-content: center;
//   display: flex;
//   position: relative;

//   label {
//     background: ${(p) =>
//       p.isFirstDayWeek || p.isLastDayWeek || p.isSelectedDay
//         ? '#e2dffd'
//         : 'none'};
//     color: ${(p) =>
//       p.isFirstDayWeek || p.isLastDayWeek || p.isSelectedDay
//         ? 'var(--text-primary)'
//         : 'var(--text-text02)'};
//     position: ${(p) =>
//       p.isFirstDayWeek || p.isLastDayWeek ? 'absolute' : 'initial'};
//     width: ${(p) => (p.isSelectedDay ? '32px' : '26px')};
//     height: ${(p) => (p.isSelectedDay ? '32px' : '26px')};
//     overflow: hidden;
//     border-radius: 50%;
//     display: flex;
//     font-weight: ${(p) =>
//       p.isFirstDayWeek || p.isLastDayWeek || p.isInsideWeek || p.isSelectedDay
//         ? 'bold'
//         : 'normal'};
//     align-content: ${(p) => (p.isLastDayWeek ? 'flex-end' : '')};
//     align-content: ${(p) => (p.isFirstDayWeek ? 'flex-start' : '')};
//     align-content: ${(p) =>
//       !p.isFirstDayWeek && !p.isLastDayWeek ? 'justify' : ''};
//     right: ${(p) => (p.isLastDayWeek ? '-7px' : 'inherit')};
//     left: ${(p) => (p.isFirstDayWeek ? '-7px' : 'inherit')};
//     align-items: center;
//     position: relative;
//     justify-content: center;
//   }

//   &&:before {
//     display: ${(p) => (p.isFirstDayWeek || p.isLastDayWeek ? 'flex' : 'none')};
//     position: absolute;
//     content: '';
//     width: 0px;
//     height: 0px;
//     border-top: 10px solid transparent;
//     border-bottom: 10px solid transparent;
//     border-right: 10px solid #e2dffd;
//     top: 3px;
//     right: ${(p) => (p.isLastDayWeek ? '14px' : 'inherit')};
//     left: ${(p) => (p.isFirstDayWeek ? '14px' : 'inherit')};
//     transform: ${(p) => (p.isFirstDayWeek ? 'rotate(180deg)' : 'rotate(0deg)')};
//   }

//   @media (max-width: 768px) {
//     width: ${(p) => (p.isFirstDayWeek || p.isLastDayWeek ? '25px' : '100%')};
//     /* label {
//       width: 100%;
//     } */
//   }
// `;

// const RegularDay = styled.div.attrs((pr: any) => ({
//   isSelectedDay: pr.isSelectedDay,
//   isBeforeToday: pr.isBeforeToday
// }))`
//   background: none;
//   width: 40px;
//   height: 40px;
//   align-items: center;
//   justify-content: center;
//   display: flex;
//   label {
//     color: ${(p) => getColor(p.isSelectedDay, p.isBeforeToday)};
//     width: 32px;
//     height: ${(p) => (p.isSelectedDay ? '32px' : '26px')};
//     overflow: hidden;
//     border-radius: 50%;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     border: ${(p) =>
//       p.isSelectedDay ? '1px solid var(--text-primary)' : '0px solid var(--text-primary)'};
//   }
//   @media (max-width: 768px) {
//     width: 100%;
//   }
// `;

// const Today = styled.div.attrs((pr: any) => ({
//   isInsideWeek: pr.isInsideWeek,
//   isFirstDayWeek: pr.isFirstDayWeek,
//   isLastDayWeek: pr.isLastDayWeek
// }))`
//   background: ${(p) =>
//     p.isInsideWeek || p.isFirstDayWeek || p.isLastDayWeek ? '#efeffe' : 'none'};
//   width: ${(p) =>
//     p.isInsideWeek || p.isFirstDayWeek || p.isLastDayWeek ? '32px' : '40px'};
//   height: ${(p) =>
//     p.isInsideWeek || p.isFirstDayWeek || p.isLastDayWeek ? '26px' : '32px'};

//   align-items: center;
//   justify-content: ${(p) => getJustify(p.isFirstDayWeek, p.isLastDayWeek)};
//   display: flex;
//   label {
//     left: ${(p) => (p.isFirstDayWeek || p.isLastDayWeek ? '-4px' : 'inherit')};
//     position: ${(p) =>
//       p.isFirstDayWeek || p.isLastDayWeek ? 'relative' : 'static'};
//     background: var(--text-primary);
//     color: #fff;
//     width: 32px;
//     height: 32px;
//     overflow: hidden;
//     border-radius: 50%;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//   }
//   @media (max-width: 768px) {
//     width: 100%;
//   }
// `;

const getBackgroundDayWrapLine = (inside: any, first: any, last: any) => {
  let background = 'none';
  if (inside || first || last) {
    background = 'var(--background-background01)';
  }
  return background;
};

const getWidthDayWrapLine = (
  inside: any,
  first: any,
  last: any,
  today: any,
  mobile: any
) => {
  let w;

  if (mobile) {
    w = '100%';

    if (inside) {
      w = '100%';
    }
    if (first || last) {
      w = '50%';
    }
    if ((first && today) || (last && today)) {
      w = '50%';
    }
  } else {
    w = '40px';

    if (inside) {
      w = '40px';
    }
    if (first || last) {
      w = '20px';
    }
    if ((first && today) || (last && today)) {
      w = '20px';
    }
  }

  return w;
};

const getBackgroundDayCircle = (
  today: any,
  last: any,
  first: any,
  selected: any,
  inside: any
) => {
  let background = 'none';
  if (selected && inside) {
    background = 'var(--background-background02)';
  }
  if (last || first) {
    background = 'var(--background-background02)';
  }

  if (today) {
    background = 'var(--text-primary)';
  }
  return background;
};

const getColorDayCircle = (
  today: any,
  last: any,
  first: any,
  selected: any
) => {
  let color = 'var(--text-text02)';
  if (last || first || selected) {
    color = 'var(--text-primary)';
  }
  if (today) {
    color = '#ffffff';
  }
  return color;
};

const getPositionArrowDayCircle = (first: any, last: any) => {
  let position;
  if (first) {
    position = {
      right: '-5px',
      left: 'auto'
    };
  }
  if (last) {
    position = {
      right: 'auto',
      left: '-5px'
    };
  }
  return position;
};

const getBorderColorDayCircle = (
  selected: any,
  inside: any,
  first: any,
  last: any
) => {
  let color = 'none';
  if (selected && !inside && !first && !last) {
    color = '1px solid var(--text-primary)';
  }

  return color;
};

const getSizeDayCircle = (first: any, last: any, today: any) => {
  let size = {
    width: '32px',
    height: '32px'
  };
  if ((first || last) && !today) {
    size = {
      width: '26px',
      height: '26px'
    };
  }

  return size;
};

const getJustifyDayWrapContent = (first: any, last: any) => {
  let justify = 'center';
  if (first) {
    justify = 'flex-start';
  }
  if (last) {
    justify = 'flex-end';
  }
  return justify;
};

const SomeDay = styled.div.attrs((pr: any) => ({
  isToday: pr.isToday,
  isFirstDayWeek: pr.isFirstDayWeek,
  isLastDayWeek: pr.isLastDayWeek,
  isInsideWeek: pr.isInsideWeek,
  isSelectedDay: pr.isSelectedDay,
  isMobile: pr.isMobile
}))`
  background: none;
  width: 100%;
  height: 40px;
  align-items: center;
  justify-content: center;
  div.wrapcontent {
    width: 100%;
    height: 26px;
    background: none;
    align-items: ${(p) =>
      getJustifyDayWrapContent(p.isLastDayWeek, p.isFirstDayWeek)};
    justify-content: ${(p) =>
      getJustifyDayWrapContent(p.isLastDayWeek, p.isFirstDayWeek)};
    display: flex;
    position: relative;
  }

  div.wrapline {
    width: ${(p) =>
      getWidthDayWrapLine(
        p.isInsideWeek,
        p.isLastDayWeek,
        p.isFirstDayWeek,
        p.isToday,
        p.isMobile
      )};
    height: 26px;
    background: ${(p) =>
      getBackgroundDayWrapLine(
        p.isInsideWeek,
        p.isFirstDayWeek,
        p.isLastDayWeek
      )};
    align-items: center;
    justify-content: ${(p) => getJustify(p.isFirstDayWeek, p.isLastDayWeek)};
    display: flex;
    position: relative;
  }

  div.float {
    left: ${(p) => (p.isFirstDayWeek || p.isLastDayWeek ? '10px' : 'inherit')};
    position: absolute;
    z-index: 2;
  }

  label.circle {
    background: ${(p) =>
      getBackgroundDayCircle(
        p.isToday,
        p.isLastDayWeek,
        p.isFirstDayWeek,
        p.isSelectedDay,
        p.isInsideWeek
      )};
    color: ${(p) =>
      getColorDayCircle(
        p.isToday,
        p.isLastDayWeek,
        p.isFirstDayWeek,
        p.isSelectedDay
      )};
    width: ${(p) =>
      getSizeDayCircle(p.isLastDayWeek, p.isFirstDayWeek, p.isToday).width};
    height: ${(p) =>
      getSizeDayCircle(p.isLastDayWeek, p.isFirstDayWeek, p.isToday).height};
    overflow: hidden;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: ${(p) =>
      getBorderColorDayCircle(
        p.isSelectedDay,
        p.isInsideWeek,
        p.isFirstDayWeek,
        p.isLastDayWeek
      )};
    font-weight: ${(p) =>
      p.isFirstDayWeek || p.isLastDayWeek || p.isInsideWeek
        ? 'bold'
        : 'normal'};
  }

  div.triangle {
    display: ${(p) =>
      (p.isFirstDayWeek || p.isLastDayWeek) && !p.isToday ? 'flex' : 'none'};
    position: absolute;
    content: '';
    width: 0px;
    height: 0px;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid #e2dffd;
    top: 3px;
    right: ${(p) =>
      getPositionArrowDayCircle(p.isFirstDayWeek, p.isLastDayWeek)?.right};
    left: ${(p) =>
      getPositionArrowDayCircle(p.isFirstDayWeek, p.isLastDayWeek)?.left};
    transform: ${(p) => (p.isFirstDayWeek ? 'rotate(180deg)' : 'rotate(0deg)')};
  }

  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
    width: 40px;
    /* div.wrapline {
      width: 40px;
    } */
    div.wrapcontent {
      width: 40px;
    }
  }
`;

// const getClassName = (it: boolean, iiw: boolean) => {
//   let classStyle = '';

//   if (it) {
//     classStyle += 'Today ';
//   }

//   if (iiw) {
//     classStyle += 'WeekDay ';
//   }

//   return classStyle;
// };

function SingleDayMonth(props: any) {
  const {
    value,
    isToday,
    isInsideWeek,
    isFirstDayWeek,
    isLastDayWeek,
    onSelectDate,
    dayDate,
    isSelectedDay
    // isBeforeToday
  } = props;
  // let SingleDay;
  // const [isSelected, setIsSelected] = useState(false);
  // const setSelectedDate = () => {
  //   setIsSelected(true);
  // };

  return (
    <SingleDayMonthWrap
      isFirstDayWeek={isFirstDayWeek}
      isLastDayWeek={isLastDayWeek}
      onClick={() => {
        // setSelectedDate();
        onSelectDate(dayDate);
      }}
    >
      {/* {SingleDay} */}
      <SomeDay
        isInsideWeek={isInsideWeek}
        isFirstDayWeek={isFirstDayWeek}
        isLastDayWeek={isLastDayWeek}
        isSelectedDay={isSelectedDay}
        isToday={isToday}
        isMobile={isMobile}
      >
        <Block className="wrapcontent">
          <Block className="wrapline" />
          <Block className="float">
            <Label className="circle" size={14} text={value} />
            <Block className="triangle" />
          </Block>
        </Block>
      </SomeDay>
    </SingleDayMonthWrap>
  );
}

export default SingleDayMonth;
